import { styled, Box, Alert, alertClasses } from '@mui/material';

export const MapContainer = styled(Box)({
  width: '100%',
  height: '100%',
});

export const MapMarkerIcon = styled('img')({
  width: 38,
  height: 50,
});

export const MapAlertInfoContainer = styled(Alert)(({ theme }) => ({
  ...theme.typography.caption,
  fontSize: theme.typography.pxToRem(10),
  position: 'absolute',
  right: '50%',
  left: '50%',
  transform: 'translateX(-50%)',
  width: `calc(100% - ${theme.spacing(5)})`,
  maxWidth: 400,
  bottom: 40,
  border: `1px solid ${theme.palette.info.light}`,
  zIndex: 1,
  padding: theme.spacing(0, 2),
  justifyContent: 'center',

  [theme.breakpoints.up('md')]: {
    bottom: 20,
    fontSize: theme.typography.pxToRem(12),
  },

  [`& .${alertClasses.message}`]: {
    textAlign: 'center',
    padding: theme.spacing(0.5, 0),

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1, 0),
    },
  },
}));
